<ng-container *ngIf="!loading$()">
    <!-- <ng-container *ngIf="!hasBenchmark$(); else dynamicDashboard"> -->
        <ng-container *ngIf="!missingFinancials$(); else missingFinancials">
            <!-- <app-section-bolletta /> -->
             <ng-container *ngTemplateOutlet="sidenavDesktop"></ng-container>
        </ng-container>
    <!-- </ng-container> -->
</ng-container>
<!-- <ng-template #dynamicDashboard>
    <ng-container>
        <app-dashboard-intro [sectionActive]="activeSection()" (clickedSection)="onClickedSection($event)" />
    </ng-container>
    <ng-container *ngIf="isMobile(); else sidenavDesktop">
        <ng-container *ngTemplateOutlet="sidenavMobile"></ng-container>
    </ng-container>
</ng-template> -->

<ng-template #sidenavMobile>
    <section #benchmark class="dashboard-benchmark sidenav-container" *ngIf="activeSection() === 'benchmark'"
        [@slideIn]="{value:'' , params: { timing:'1000ms' , delay: '500ms'}}">
        <ng-container *ngIf="company && !missingFinancials$(); else missingFinancials">
            <app-section-benchmark [company]="company" [companyEureso]="companyEureso" [companyAteco]="companyAteco"></app-section-benchmark>
        </ng-container>
         <div class="bg-gradient-2 d-flex pt--60 pb--60 place-content-center">
                <button mat-stroked-button color="white" (click)="closeSidenav()"  class="p--24 fs-20 rounded">Scopri Obiettivo Europa</button>
            </div>
    </section>
    <!-- <section #obiettivoeuropa class="dashboard-obiettivo-europa sidenav-container"
        *ngIf="activeSection() == 'obiettivoeuropa'"
        [@slideInRight]="{value:'' , params: { timing:'1000ms' , delay: '500ms'}}">
        <app-section-oe></app-section-oe>
        <div class="bg-gradient-2 d-flex pt--60 pb--60 place-content-center">
            <button mat-stroked-button color="white" (click)="closeSidenav()" class="p--24 fs-20 rounded">Scopri il Benchmark</button>
        </div>
    </section> -->
</ng-template>

<ng-template #sidenavDesktop>
    <section id="benchmark" class="container-fluid p--0">
        <ng-container *ngIf="company && !missingFinancials$(); else missingFinancials">
            <app-section-benchmark [company]="company" [companyEureso]="companyEureso" [companyAteco]="companyAteco"></app-section-benchmark>
        </ng-container>
        <app-section-products-related />
        <app-section-trials />
        <!-- <products-related [skus]="productSkusToPromote$()"></products-related> -->
    </section>
   
</ng-template>


<ng-template #missingFinancials>
    <company-data-error [errors]="companyAnalizingErrors$()" [company]="companyEureso"
        [piva]="companyPiva"></company-data-error>
</ng-template>